// extracted by mini-css-extract-plugin
export default {"MenuGroup--max-height":"bga_a"};